import React from "react";
import { object } from "prop-types";
import { Link } from "@quintype/components";

import "./attachment-element.m.css";

const AttachmentElement = ({ element }) => (
  <div styleName="wrapper">
    <div styleName="file-name">
      <span styleName="pdf-button">PDF</span>
      {element["file-name"]}
    </div>
    <Link href={element.url} target="_blank" rel="noopener noreferrer" aria-label="preview-button">
      <div styleName="preview-button">Preview</div>
    </Link>
  </div>
);

AttachmentElement.propTypes = {
  element: object,
};

export default AttachmentElement;
